'use client';
import * as React from 'react';

import { OpenDialog, CloseDialog } from './useDialogs';

/**
 * @ignore - internal component.
 */

export const DialogsContext = React.createContext<{
  open: OpenDialog;
  close: CloseDialog;
} | null>(null);
